import { reminderBefore } from '../strings.locstring.json';
import loc, { format } from 'owa-localize';

import { createLowercaseFormatter } from 'owa-duration-formatter/lib/lowercase';

const SECONDS_IN_MINUTE = 60;

export default function getNonAllDayReminderString(selectedReminderTimeInMinutes: number): string {
    let lowercaseFormatter = createLowercaseFormatter();
    return format(
        loc(reminderBefore),
        lowercaseFormatter(selectedReminderTimeInMinutes * SECONDS_IN_MINUTE)
    );
}
